export enum ChecklistRunStatus {
  PENDING = 'PENDING',
  IN_PROGRESS = 'IN_PROGRESS',
  LATE = 'LATE',
  SENT = 'SENT',
  NOT_DONE = 'NOT_DONE',
  CANCELED = 'CANCELED',
}

export enum ChecklistOrigin {
  ACTIVITY = 'ACTIVITY',
  SCHEDULE = 'SCHEDULE',
  FRANCHISOR = 'FRANCHISOR',
}

export enum ChecklistQuestionType {
  YES_NO = 'YES_NO',
  QUALITY = 'QUALITY',
  NUMBER = 'NUMBER',
  PHOTO = 'PHOTO',
  TEXT = 'TEXT',
}

export enum ChecklistPhotoSource {
  CAMERA = 'CAMERA',
  FILE = 'FILE',
}

export enum ChecklistListTab {
  ALL = 'ALL',
  PENDING = 'PENDING',
}

export type ChecklistOption = { value: string; label: string; points: number; problem: boolean };

export type ChecklistQuestion = {
  id: string;
  number: string;
  text: string;
  type: ChecklistQuestionType;
  required: boolean;
  photoRequired: boolean;
  allowsNotApplicable: boolean;
  hint?: string;
  planogramLabel?: string;
  unit?: string;
  expectedRange?: string;
  options: ChecklistOption[];
};

export type ChecklistSection = { id: string; title: string; questions: ChecklistQuestion[] };

export type ChecklistTemplate = {
  id: string;
  name: string;
  coverUrl: string;
  estimatedMinutes: number;
  sections: ChecklistSection[];
};

export type ChecklistPhoto = { id: string; url: string; source: ChecklistPhotoSource; takenAt: string };

export type ChecklistAnswer = {
  questionId: string;
  value?: string;
  notApplicable: boolean;
  comment: string;
  photos: ChecklistPhoto[];
  answeredAt: string;
  answeredBy: string;
  problem: boolean;
  points?: number;
  maxPoints?: number;
};

export type ChecklistAnswerInput = {
  questionId: string;
  value?: string;
  notApplicable: boolean;
  comment: string;
  photos: ChecklistPhoto[];
};

export type ChecklistAnswerChange = {
  questionId: string;
  value?: string;
  notApplicable?: boolean;
  comment?: string;
  photos?: ChecklistPhoto[];
};

export type ChecklistActivity = { taskId: string; label: string; path?: string; mandatory: boolean };

export type ChecklistActivityRef = { taskId: string; label: string; path: string; store: string };

export type ChecklistCheckout = {
  comment: string;
  signatureUrl: string;
  signedBy: string;
  signedAt: string;
  location?: string;
};

export type ChecklistCheckoutInput = { comment: string; signatureUrl: string; location?: string };

export type ChecklistSectionScore = {
  sectionId: string;
  points: number;
  maxPoints: number;
  percent: number;
  problems: number;
};

export type ChecklistScore = {
  points: number;
  maxPoints: number;
  percent: number;
  problems: number;
  notApplicable: number;
  photos: number;
  sections: ChecklistSectionScore[];
};

export type ChecklistProgress = { answered: number; total: number };

export type ChecklistRun = {
  id: string;
  templateId: string;
  templateName: string;
  coverUrl: string;
  store: string;
  origin: ChecklistOrigin;
  activity?: ChecklistActivity;
  appliedBy?: string;
  dueAt: string;
  status: ChecklistRunStatus;
  progress: ChecklistProgress;
  startedAt?: string;
  startedBy?: string;
  startLocation?: string;
  sentAt?: string;
  sentBy?: string;
  score?: ChecklistScore;
  answers: ChecklistAnswer[];
  checkout?: ChecklistCheckout;
};

export type ChecklistRunDetail = ChecklistRun & { template: ChecklistTemplate };

export type ChecklistVisitEvent = {
  time: string;
  title: string;
  detail: string;
  tone: 'primary' | 'success' | 'danger';
};

export type ActivityChecklistGate = {
  blockingRun?: ChecklistRun;
  isModalOpen: boolean;
  requestFinish: (finish: () => void) => void;
  closeModal: () => void;
  finishWithoutChecklist: () => void;
  confirmFinished: () => void;
  cancelActivity: () => void;
};
